import { Table } from "@tanstack/react-table";

import { EmptyTableBox } from "../../Table/EmptyTableBox";
import { NoResults } from "../../Table/NoResults";
import { StickyHeaderOverflowTable } from "../../Table/StickyHeaderOverflowTable";
import { TSTHead } from "../TSTTable/TSTHead";

import { TSTExpandableRows } from "./TSTExpandableRows";

interface TSTExpandableTableProps<T> {
    table: Table<T>;
    noResultsFallback: React.ReactNode;
    noSourceRowsFallback: React.ReactNode;
    /** A `<TableToolbar>`, pinned alongside the head instead of scrolling away. */
    toolbar?: React.ReactNode;
    tableRef?: React.RefObject<HTMLDivElement | null>;
    renderSubComponent: (row: T) => React.ReactNode;
}
export function TSTExpandableTable<T>({
    table,
    noResultsFallback,
    noSourceRowsFallback,
    toolbar,
    tableRef,
    renderSubComponent,
}: TSTExpandableTableProps<T>) {
    const hasSourceRows = table.options.data.length > 0;
    const hasRows = table.getRowModel().rows.length > 0;

    if (!hasRows) {
        return (
            <>
                {toolbar}
                <EmptyTableBox>
                    <NoResults
                        description={
                            hasSourceRows
                                ? noResultsFallback
                                : noSourceRowsFallback
                        }
                    />
                </EmptyTableBox>
            </>
        );
    }
    return (
        <StickyHeaderOverflowTable
            tableRef={tableRef}
            bodyComponent={
                <TSTExpandableRows
                    table={table}
                    renderSubComponent={renderSubComponent}
                />
            }
            headComponent={<TSTHead table={table} />}
            contentWidth={table.getTotalSize()}
            toolbarComponent={toolbar}
        />
    );
}
